export default "__VITE_ASSET__d3a5660f__"